<ng-container *ngIf="dispDialog; else kymw0A00contents">
  <table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
    [frontDispFlag]="false">
    <tr class="subwindow-title" cdkDragHandle>
      <th class="window-title-name">組合員の声選択</th>
      <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
    </tr>
    <tr class="subwindow-body">
      <td>
        <ng-container *ngIf="dispDialog; then kymw0A00contents"></ng-container>
      </td>
    </tr>
    <tfoot cdkDragHandle>
      <tr>
        <td>
          <div class="footer-buttons">
            <button id="btn_UploadMembersVoiceData" #btn_UploadMembersVoiceData class="btn-secondary" [disabled]="!kymw0A00Model.uploadMembersVoiceDataEnabled"
              (click)="eventUploadMembersVoiceDataButton()" forcedEnabledMode="" [tabindex]="0">組合員の声取込</button>
            <button id="btn_DownloadMembersVoiceData" #btn_DownloadMembersVoiceData class="btn-secondary"
              (click)="eventDownloadMembersVoiceDataButton()" forcedEnabledMode="true" [tabindex]="0">掲載組合員の声出力</button>
            <button id="btn_Update" #btn_Update class="btn-primary" [style.display]="kymw0A00Model.btnUpdateVisible ? 'none' : ''"
              (click)="eventUpdateHandler()" forcedEnabledMode="" [tabindex]="0">更新</button>
            <button id="btn_Select" #btn_Select class="btn-primary"
              [style.display]="kymw0A00Model.btnSelectVisible" (click)="eventSelectHandler()" forcedEnabledMode=""
              [tabindex]="0">選択</button>
          </div>
          <div class="window-title-close">
            <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
            <button [tabindex]="0" (click)="onClickWindowClose()"></button>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</ng-container>

<ng-template #kymw0A00contents>
  <div class="contents-area">
    <div class="element-column">
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title" id="lbl_PcodeListLbl"
            [style.visibility]="kymw0A00Model.lblPcodeListLblVisible">選択Ｐコード</label>
          <div class="list-input-content">
            <select class="combo-box-normal pcode" id="cmb_PcodeList" #cmb_PcodeList
              [(ngModel)]="kymw0A00Model.pcodeListSelectedValue" [style.visibility]="kymw0A00Model.cmbPcodeListVisible"
              (change)="eventPcodeListChangeHandler($event)" forcedEnabledMode="true" [tabindex]="0">
              <ng-template ngFor let-item [ngForOf]="kymw0A00Model.pcodeList">
                <option value="{{item.Pcode}}">{{item.Caption}}</option>
              </ng-template>
            </select>
          </div>
        </div>
        <div class="column-list">
          <label class="list-input-title"
            [style.visibility]="kymw0A00Model.lblGuideGoodsNameLblVisible">商品案内用商品名</label>
          <div class="list-input-content" style="width: 36rem;">
            <input type="text" readonly
              [style.visibility]="kymw0A00Model.lblGuideGoodsNameVisible" value="{{kymw0A00Model.guideGoodsName}}">
          </div>
        </div>
        <div class="column-list">
          <label class="list-input-title"
            [style.visibility]="kymw0A00Model.lblGuideStandardNameLblVisible">商品案内用規格名</label>
          <div class="list-input-content" style="width: 18rem;">
            <input type="text" readonly
              [style.visibility]="kymw0A00Model.lblGuideStandardNameVisible" value="{{kymw0A00Model.guideStandardName}}">
          </div>
        </div>
      </div>
      <div class="element-column" style="width: 1623px;">
        <button class="btn-secondary" id="btn_Search" #btn_Search (click)="eventSearchHandler()"
          forcedEnabledMode="true" [tabindex]="0">組合員の声検索</button>
        <div class="action-area">
          <app-pager [prevDisabled]="!btnBackEnabled" [nextDisabled]="!btnNextEnabled" [totalNum]="kymw0A00Model.totalNum"
            [startNum]="kymw0A00Model.startDispNum" [endNum]="kymw0A00Model.endDispNum" (prevHandler)="eventBackHandler()"
            (nextHandler)="eventNextHandler()">
          </app-pager>
        </div>
       <wj-flex-grid class="space-bottom" id="dtg_MembersVoiceList" #dtg_MembersVoiceList
          [itemsSource]="kymw0A00Model.membersVoiceArray" [isReadOnly]="true" [allowSorting]="false"
          [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'"
          (click)="eventMembersVoiceListHeaderReleaseHandler($event, dtg_MembersVoiceList)"
          (itemsSourceChanged)="eventItemSourceChangedMembersVoiceListHandler()" forcedEnabledMode="true" [tabindex]="0">
          <wj-flex-grid-column [minWidth]="5" [header]="'会員受付日'" [width]="90"
            [binding]="'ReceiptDate'"></wj-flex-grid-column>          <wj-flex-grid-column [minWidth]="5" [header]="'生協名'" [width]="100" [binding]="'CoopName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'組合員名(漢字)'" [width]="120"
            [binding]="'MemberName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'匿名希望者'" [width]="120"
            [binding]="'Anonymous'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [width]="90" [binding]="'ClassName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [width]="238"
            [binding]="'Subject'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'い'" [width]="30" [binding]="'PublishCoop1'"
            [align]="'center'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'と'" [width]="30" [binding]="'PublishCoop2'"
            [align]="'center'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ぐ'" [width]="30" [binding]="'PublishCoop3'"
            [align]="'center'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ち'" [width]="30" [binding]="'PublishCoop4'"
            [align]="'center'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'さ'" [width]="30" [binding]="'PublishCoop5'"
            [align]="'center'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'とう'" [width]="35" [binding]="'PublishCoop6'"
            [align]="'center'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'な'" [width]="30" [binding]="'PublishCoop7'"
            [align]="'center'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'に'" [width]="30" [binding]="'PublishCoop8'"
            [align]="'center'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ク'" [width]="30" [binding]="'PublishCoop9'"
            [align]="'center'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'問合せ内容'" [width]="220"
            [binding]="'InquiryContents'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'掲載区分'" [width]="80"
            [binding]="'PublishTypeName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [width]="80" [binding]="'Pcode'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'センター名'" [width]="90"
            [binding]="'CenterName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'受付番号'" [width]="100"
            [binding]="'ReceiptNum'"></wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </div>
    <div class="element-column">
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">会員受付日</label>
          <div class="list-input-content">
            <input type="text" value="{{kymw0A00Model.receiptDate}}" readonly>
          </div>
          <label class="list-input-title">組合員名(漢字)</label>
          <div class="list-input-content" style="width: 22rem;">
            <input type="text" value="{{kymw0A00Model.memberName}}" readonly>
          </div>
          <label class="list-input-title">部門</label>
          <div class="list-input-content">
            <input type="text" value="{{kymw0A00Model.className}}" readonly>
          </div>
        </div>
        <div class="column-list">
          <label class="list-input-title">生協名</label>
          <div class="list-input-content">
            <input type="text" value="{{kymw0A00Model.coopName}}" readonly>
          </div>
          <label class="list-input-title">匿名希望者</label>
          <div class="list-input-content">
            <input type="text" value="{{kymw0A00Model.anonymous}}" readonly>
          </div>
          <label class="list-input-title">商品名</label>
          <div class="list-input-content" style="width: 32rem;">
            <input type="text" value="{{kymw0A00Model.subject}}" readonly>
          </div>
        </div>
        <div class="column-list" style="height: max-content;">
          <label class="list-input-title">Ｐコード</label>
          <div class="list-input-content" style="width: 7rem;">
            <input type="text" value="{{kymw0A00Model.pcode}}" readonly>
          </div>
          <label class="list-input-title">受付番号</label>
          <div class="list-input-content" style="width: 8rem;">
            <input type="text" value="{{kymw0A00Model.receiptNum}}" readonly>
          </div>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title">問合せ内容</label>
        <div class="list-input-content">
          <textarea class="text-label-normal" id="txta_InquiryContents" [ngModel]="kymw0A00Model.inquiryContents"
            plessInputTextSub [restrict]="'[ -￮]'" [readonly]="true"></textarea>
        </div>
      </div>
    </div>
    <div>
      <h2>誌面掲載用項目</h2>
      <div class="element-column">
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">組合員名(漢字)</label>
            <div class="list-input-content" style="width: 22rem;">
              <app-text-input id="txti_CorrectMemberName" #txti_CorrectMemberName [subid]="'txti_CorrectMemberName'"
                [(ngModel)]="kymw0A00Model.correctMemberName" [restrict]="'[ -￮]'" [maxChars]="20" [fullOnly]="true" [displayCountField]="false"
                [forcedEnabledMode]="''" [tabindex]="0">
              </app-text-input>
            </div>
            <label class="list-input-title">使用名</label>
            <div class="list-input-content">
              <app-radio-label name="rdbg_CenterCoopDiv" label="生協名" value="1" id="rdbg_Coop" #rdbg_Coop
                [subid]="'rdbg_Coop'" [(ngModel)]="kymw0A00Model.correctCenterCoopDiv" [forcedEnabledMode]="''"
                [tabindex]="0">
              </app-radio-label>
              <app-radio-label name="rdbg_CenterCoopDiv" label="センター名" value="2" id="rdbg_Center" #rdbg_Center
                [subid]="'rdbg_Center'" [(ngModel)]="kymw0A00Model.correctCenterCoopDiv" [forcedEnabledMode]="''"
                [tabindex]="0">
              </app-radio-label>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">匿名希望者</label>
            <div class="list-input-content" style="width: 22rem;">
              <app-not-null-text-input id="txti_CorrectAnonymous" #txti_CorrectAnonymous
                [subid]="'txti_CorrectAnonymous'" [(ngModel)]="kymw0A00Model.correctAnonymous" [required]="true"
                [useDisabledBgColor]="true" [restrict]="'[ -￮]'" [maxChars]="20" [fullOnly]="true"
                [displayCountField]="false" [forcedEnabledMode]="''" [tabindex]="0">
              </app-not-null-text-input>
            </div>
            <label class="list-input-title">センター名</label>
            <div class="list-input-content">
              <app-text-input id="txti_CenterName" #txti_CenterName [subid]="'txti_CenterName'"
                [(ngModel)]="kymw0A00Model.correctCenterName" [restrict]="'[ -￮]'" [maxChars]="10" [fullOnly]="true"
                class="relative" [displayCountField]="false" [forcedEnabledMode]="''" [tabindex]="0">
              </app-text-input>
            </div>
          </div>
        </div>
        <div class="column-list">
          <label class="list-input-title">問合せ内容</label>
          <div class="list-input-content">
            <app-text-area id="txta_InquiryContents" #txta_InquiryContents [subid]="'txta_InquiryContents'"
              [(ngModel)]="kymw0A00Model.correctInquiryContents" [restrict]="'[ -￮]'" [maxChars]="200" [fullOnly]="true"
              [displayCountField]="true" [forcedEnabledMode]="''" [tabindex]="0" [height]="66">
            </app-text-area>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="footer-buttons" *ngIf="!dispDialog">
    <button id="btn_UploadMembersVoiceData" #btn_UploadMembersVoiceData class="btn-secondary" [disabled]="!kymw0A00Model.uploadMembersVoiceDataEnabled"
      (click)="eventUploadMembersVoiceDataButton()" forcedEnabledMode="" [tabindex]="0">組合員の声取込</button>
    <button id="btn_DownloadMembersVoiceData" #btn_DownloadMembersVoiceData class="btn-secondary"
      (click)="eventDownloadMembersVoiceDataButton()" forcedEnabledMode="true" [tabindex]="0">掲載組合員の声出力</button>
    <button id="btn_Update" #btn_Update class="btn-primary" [style.display]="kymw0A00Model.btnUpdateVisible ? 'none' : ''"
      (click)="eventUpdateHandler()" forcedEnabledMode="" [tabindex]="0">更新</button>
    <button id="btn_Select" #btn_Select class="btn-primary" [style.display]="kymw0A00Model.btnSelectVisible ? 'none' : ''"
      (click)="eventSelectHandler()" forcedEnabledMode="" [tabindex]="0">選択</button>
  </footer>
</ng-template>